import { getDynamicRoute } from 'lib/frontend/utils/router';
import { OrderModel } from 'lib/model/objects/orderModel';
import { TriggerEventMap } from 'lib/types/syncAttempt';
import { Link } from 'react-router-dom';
import { AdDetailsCardRow } from './AdDetailsCardRow';
import { SyncAttemptStatusBadge } from './OrderDetailDrawerTabs/SyncAttemptsTab';
import {
  ProductToRoutesMap,
  useSyncAttempts
} from './OrderDetailDrawerTabs/useSyncAttempts';

export function AdDetailsSyncAttemptCard({ order }: { order: OrderModel }) {
  const routes = ProductToRoutesMap[order.modelData.product];
  const syncAttempts = useSyncAttempts(order.ref);

  if (syncAttempts.length === 0 || !routes) {
    return null;
  }

  const { syncAttempt, triggerEvent } = syncAttempts[0];

  return (
    <AdDetailsCardRow
      label="Latest Sync Attempt"
      value={
        <div className="flex items-center justify-between gap-2">
          <Link
            to={getDynamicRoute(routes.SYNC_ATTEMPTS, { id: order.id })}
            className="flex flex-col gap-2 underline"
          >
            {TriggerEventMap[triggerEvent.modelData.type]}
          </Link>
          <SyncAttemptStatusBadge status={syncAttempt.modelData.status} />
        </div>
      }
    />
  );
}
